import React, { FC } from "react";

interface Props {
  dayOfMonth: number;
  date?: Date | undefined;
  unavailableDates?: Date[];
  partiallyUnavailable?: boolean;
  partialTimes?: { from: string; to: string }[];
  /** No pick-up or drop-off time is left on this day, so it can't be chosen (1NOW-11215). */
  noTimes?: boolean;
}

const DatePickerCustomDay: FC<Props> = ({
  dayOfMonth,
  date,
  unavailableDates = [],
  partiallyUnavailable = false,
  partialTimes = [],
  noTimes = false,
}) => {
  const isUnavailable = date
    ? unavailableDates.some(
        (unavailableDate) =>
          unavailableDate.toDateString() === date.toDateString()
      )
    : false;

  return (
    <span
      className={`react-datepicker__day_span flex flex-col items-center ${
        isUnavailable || noTimes ? "line-through" : ""
      }`}
      title={noTimes ? "No pick-up or return times this day" : undefined}
    >
      <span>{dayOfMonth}</span>
      <div
        className="w-6 h-1 rounded border-[0.5px] border-secondary-100"
        style={{
          background: isUnavailable || noTimes
            ? "red"
            : partiallyUnavailable
            ? "linear-gradient(to right, red 50%, green 50%)"
            : "green",
        }}
      />
      {/* {!isUnavailable && partiallyUnavailable && partialTimes && (
      <span title={partialTimes.map((t) => `${t.from} - ${t.to}`).join(", ")}>
        ⚠️
      </span>
      )} */}
    </span>
  );
};

export default DatePickerCustomDay;